import React from 'react';
import '../../App.scss';
import { Button, Accordion, Badge, Table, Modal, Form } from 'react-bootstrap'; // Form eklendi
import AuthorizedPage from '../../component/AuthorizedPage';
import { Role } from '../../domain/Role';
import If from '../../component/If';
import WaybillApi from '../../api/WaybillApi';
import ShipmentApi from '../../api/ShipmentApi';
import InfoToast from '../../component/InfoToast';

// Data Modeli
interface ShipmentGroup {
    shipmentId: number;
    driverName: string;
    plateNumber: string;
    documentDate: string;
    shipmentStatus: string;
    shipmentStatusLabel: string;
    waybills: any[];
}

// State Yapısı
const initialState = {
    allShipmentGroups: [] as ShipmentGroup[], // 🔥 TÜM VERİ (Yedek)
    shipmentGroups: [] as ShipmentGroup[],    // 🔥 EKRANDA GÖZÜKEN (Filtrelenmiş)

    // 🔥 TEK FİLTRE: Tamamlananları Gizle
    hideCompleted: false,

    isLoading: false,

    // Toast
    toastShow: false,
    toastMessage: "" as any,
    toastVariant: "success",
    toastDelay: 3000,

    // Modal
    modalShow: false,
    modalMessage: ""
};

class SalesWaybills extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.state = initialState;
        this.loadData = this.loadData.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    async loadData() {
        this.setState({ isLoading: true });
        try {
            // Backend'den tüm veriyi çekiyoruz
            const response = await WaybillApi.list({});
            if (response.success) {
                this.setState({
                    allShipmentGroups: response.data,
                    shipmentGroups: response.data
                }, () => {
                    this.applyFrontendFilters();
                });
            } else {
                this.showModalError((response as any).message || "İrsaliye listesi alınamadı!");
            }
        } catch (error) {
            console.error("API Hatası:", error);
            this.showModalError("Sunucu ile bağlantı kurulamadı.");
        } finally {
            this.setState({ isLoading: false });
        }
    }

    // 🔥 SADELEŞTİRİLMİŞ FİLTRE MANTIĞI
    handleFilterChange = (e: any) => {
        this.setState({ hideCompleted: e.target.checked }, () => {
            this.applyFrontendFilters();
        });
    }

    applyFrontendFilters() {
        const { allShipmentGroups, hideCompleted } = this.state;
        if (!allShipmentGroups) return;

        let filtered = allShipmentGroups;

        // Sadece "Tamamlananları Gizle" seçiliyse filtrele
        if (hideCompleted) {
            filtered = allShipmentGroups.filter((group: ShipmentGroup) => {
                const isCompleted =
                    group.shipmentStatus === 'DELIVERY_COMPLETED' ||
                    group.shipmentStatus === 'CANCELLED';

                // Tamamlanmışsa (veya iptalse) ve biz gizlemek istiyorsak -> FALSE döndür (Listeye alma)
                return !isCompleted;
            });
        }

        this.setState({ shipmentGroups: filtered });
    }

    // --- AKSİYONLAR ---

    async handleRevertShipment(shipmentId: number, driverName: string) {
        if (!shipmentId || shipmentId === 0) return;
        const confirmMsg = `DİKKAT! ⚠️\n\n"${driverName}" şoförlü SEVKİYAT geri alınacak.\nOnaylıyor musunuz?`;
        if (!window.confirm(confirmMsg)) return;

        this.setState({ isLoading: true });
        try {
            const response = await WaybillApi.revertShipment(shipmentId);
            if (response.success) {
                this.showSuccessToast("Sevkiyat başarıyla geri alındı! ↩️");
                this.loadData();
            } else {
                const res = response as any;
                this.showModalError(res.message || res.error?.message || "Geri alma başarısız.");
            }
        } catch (err: any) {
            this.showModalError(err.message || "Bir hata oluştu.");
        } finally {
            this.setState({ isLoading: false });
        }
    }

    async handleStartDelivery(shipmentId: number, driverName: string) {
        if (!shipmentId || shipmentId === 0) return;

        const confirmMsg = `ONAYLIYOR MUSUNUZ? 🚚\n\n"${driverName}" için stok düşümü yapılacak ve araç yola çıkacak.\nDevam edilsin mi?`;
        if (!window.confirm(confirmMsg)) return;

        this.setState({ isLoading: true });
        try {
            const response = await ShipmentApi.startDelivery(shipmentId);
            if (response.success) {
                this.showSuccessToast("Sevkiyat başarıyla başlatıldı! Araç yola çıktı. 🛣️");
                this.loadData();
            } else {
                const res = response as any;
                const msg = res.message || (res.error && res.error.message) || res.error || "Sevkiyat başlatılamadı.";
                this.showModalError(msg);
            }
        } catch (err: any) {
            console.error(err);
            this.showModalError(err.message || "Bir hata oluştu.");
        } finally {
            this.setState({ isLoading: false });
        }
    }

    async handleDeleteFromLogo(item: any) {
        if (!window.confirm(`"${item.waybillNumber}" silinecek. Emin misiniz?`)) return;
        this.setState({ isLoading: true });
        try {
            const response = await WaybillApi.deleteFromLogo(item.id);
            if (response.success) {
                this.showSuccessToast("İrsaliye Logo'dan silindi! 🗑️");
                this.loadData();
            } else {
                this.showModalError((response as any).message || "Silme işlemi başarısız.");
            }
        } catch (err: any) {
            this.showModalError(err.message);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    async handleCreateLogoOrder(item: any) {
            if (!window.confirm("Sipariş oluşturulsun mu?")) return;
            this.setState({ isLoading: true });
            try {
                const response = await WaybillApi.createLogoOrder(item.id);
                if (response.success) {
                    this.showSuccessToast("Logo Sipariş oluşturuldu! ✅");
                    this.loadData();
                } else {
                    // 🔥 DÜZELTME: (response as any) eklendi ve error.message kontrolü de eklendi
                    const errorMsg = (response as any).message || (response as any).error?.message || (response as any).error || "İşlem başarısız";
                    this.showModalError(errorMsg);
                }
            } catch (err: any) {
                console.error("Logo Hatası:", err);
                // Catch bloğu aynen kalıyor
                const rawMsg = err.response?.data?.error?.message || err.message || "Bilinmeyen Hata";
                this.showModalError(rawMsg);
            } finally {
                this.setState({ isLoading: false });
            }
    }

        async handleCreateLogoWaybill(item: any) {
                if (!window.confirm("İrsaliye oluşturulsun mu?")) return;
                this.setState({ isLoading: true });
                try {
                    const response = await WaybillApi.createLogoWaybill(item.id);
                    if (response.success) {
                        this.showSuccessToast("Logo İrsaliye oluşturuldu! 🚛");
                        this.loadData();
                    } else {
                        // 🔥 DÜZELTME: (response as any) eklendi
                        const errorMsg = (response as any).message || (response as any).error?.message || (response as any).error || "İşlem başarısız";
                        this.showModalError(errorMsg);
                    }
                } catch (err: any) {
                    console.error("Logo Hatası:", err);
                    // Catch bloğu aynen kalıyor
                    const rawMsg = err.response?.data?.error?.message || err.message || "Bilinmeyen Hata";
                    this.showModalError(rawMsg);
                } finally {
                    this.setState({ isLoading: false });
                }
        }

    showSuccessToast(message: string) {
        this.setState({ toastShow: true, toastVariant: 'success', toastMessage: message, toastDelay: 3000 });
    }

    showModalError(message: string) {
        const safeMessage = message || "Bilinmeyen Hata";
        const formattedMessage = safeMessage.toString().split(" | ").join("\n");
        this.setState({ modalShow: true, modalMessage: formattedMessage });
    }

    formatCurrency(amount: number) {
        return new Intl.NumberFormat('tr-TR', {
            style: 'currency',
            currency: 'TRY',
            minimumFractionDigits: 2
        }).format(amount);
    }

    renderShipmentGroups = () => {
        const groups = this.state.shipmentGroups;

        if (!groups || groups.length === 0) {
            return (
                <div className="text-center mt-4 p-5 bg-white border rounded shadow-sm">
                    <h5 className="text-muted">Görüntülenecek kayıt bulunamadı.</h5>
                </div>
            );
        }

        return (
            <Accordion defaultActiveKey="0" className="mt-3">
                {groups.map((group: ShipmentGroup, index: number) => {

                    const isAllSyncedToLogo = true;
                    const isAlreadyShipped =
                        group.shipmentStatus === 'ON_DELIVERY' ||
                        group.shipmentStatus === 'DELIVERED' ||
                        group.shipmentStatus === 'DELIVERY_COMPLETED';

                    let badgeBg = "secondary";
                    if (group.shipmentStatus === 'LOADING') badgeBg = "warning";
                    else if (group.shipmentStatus === 'LOADED') badgeBg = "info";
                    else if (group.shipmentStatus === 'ON_DELIVERY') badgeBg = "primary";
                    else if (group.shipmentStatus === 'DELIVERED' || group.shipmentStatus === 'DELIVERY_COMPLETED') badgeBg = "success";

                    return (
                        <Accordion.Item eventKey={index.toString()} key={group.shipmentId} className="mb-3 border shadow-sm">
                            <Accordion.Header>
                                <div className="d-flex w-100 justify-content-between align-items-center me-3">
                                    <div className="d-flex align-items-center gap-3">
                                        <Badge bg="dark" className="p-2 fs-6">🚛 {group.plateNumber}</Badge>
                                        <div className="d-flex flex-column">
                                            <span className="fw-bold text-dark">{group.driverName}</span>
                                            <small className="text-muted">
                                                {group.documentDate ? new Date(group.documentDate).toLocaleDateString("tr-TR") : "-"}
                                            </small>
                                        </div>
                                    </div>
                                    <div className="text-end d-flex flex-column align-items-end">
                                        <Badge bg={badgeBg} className="mb-1">{group.shipmentStatusLabel}</Badge>
                                        <div className="small text-muted">{group.waybills.length} İrsaliye</div>
                                    </div>
                                </div>
                            </Accordion.Header>

                            <Accordion.Body className="bg-light p-3">
                                <div className="d-flex justify-content-between align-items-center mb-3 bg-white p-2 rounded border">
                                    <strong className="text-primary ps-2">Sevkiyat İçeriği (Ref: {group.shipmentId})</strong>
                                    <div className="pe-2 d-flex gap-2 align-items-center">

                                        <If value={!isAlreadyShipped}>
                                            <Button variant="outline-danger" size="sm" onClick={() => this.handleRevertShipment(group.shipmentId, group.driverName)} disabled={this.state.isLoading}>
                                                ↩️ Sevkiyatı Geri Al
                                            </Button>
                                        </If>

                                        <If value={!isAlreadyShipped && isAllSyncedToLogo}>
                                            <Button variant="success" size="sm" onClick={() => this.handleStartDelivery(group.shipmentId, group.driverName)} disabled={this.state.isLoading} className="fw-bold">
                                                🚛 Sevkiyatı Yola Çıkar
                                            </Button>
                                        </If>

                                        <If value={isAlreadyShipped}>
                                            <span className="text-success fw-bold small border px-2 py-1 rounded bg-light">✅ İşlem Tamamlandı</span>
                                        </If>

                                    </div>
                                </div>

                                <div className="table-responsive bg-white rounded border shadow-sm">
                                    <Table hover className="mb-0 align-middle">
                                        <thead className="bg-light text-secondary">
                                            <tr>
                                                <th className="ps-3">İrsaliye No</th>
                                                <th>Müşteri</th>
                                                <th>Durum</th>
                                                <th className="text-end pe-3">İşlemler</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {group.waybills.map((waybill: any) => {
                                                const waybillTotal = waybill.items
                                                    ? waybill.items.reduce((acc: number, item: any) => acc + (item.quantity * item.price), 0)
                                                    : 0;

                                                return (
                                                    <React.Fragment key={waybill.id}>
                                                        <tr className="bg-white">
                                                            <td className="ps-3 font-monospace fw-bold text-primary">#{waybill.waybillNumber}</td>
                                                            <td className="fw-500">{waybill.buyerTitle}</td>
                                                            <td><Badge bg={waybill.status === 'DRAFT' ? 'secondary' : 'success'}>{waybill.statusLabel || waybill.status}</Badge></td>
                                                            <td className="text-end pe-3">
                                                                <div className="d-flex justify-content-end gap-2">
                                                                    <Button variant={waybill.logoOrderLogicalRef ? "light" : "outline-primary"} size="sm" onClick={() => this.handleCreateLogoOrder(waybill)} disabled={!!waybill.logoOrderLogicalRef || this.state.isLoading}>
                                                                        {waybill.logoOrderLogicalRef ? "✅ Sip. OK" : "Logo Sip."}
                                                                    </Button>
                                                                    {!waybill.logoWaybillLogicalRef ? (
                                                                        <Button variant="outline-warning" size="sm" onClick={() => this.handleCreateLogoWaybill(waybill)} disabled={this.state.isLoading}>Logo İrs.</Button>
                                                                    ) : (
                                                                        <Button variant="outline-danger" size="sm" onClick={() => this.handleDeleteFromLogo(waybill)} disabled={this.state.isLoading}>🗑️ İrsaliye Sil</Button>
                                                                    )}
                                                                    <Button variant="outline-secondary" size="sm">🖨️</Button>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td colSpan={4} className="p-0 border-top-0">
                                                                <div className="bg-light-subtle px-4 py-2 mb-3 border-bottom" style={{ marginLeft: '10px', borderLeft: '4px solid #0d6efd' }}>
                                                                    <Table size="sm" className="mb-0 bg-transparent" borderless>
                                                                        <thead>
                                                                            <tr className="text-muted small border-bottom">
                                                                                <th>Stok Kodu</th>
                                                                                <th>Ürün Adı</th>
                                                                                <th className="text-end">Miktar</th>
                                                                                <th className="text-end">Birim</th>
                                                                                <th className="text-end">Birim Fiyat</th>
                                                                                <th className="text-end">Tutar</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {waybill.items && waybill.items.map((item: any, i: number) => {
                                                                                const lineTotal = item.quantity * item.price;
                                                                                return (
                                                                                    <tr key={i}>
                                                                                        <td className="font-monospace text-muted small">{item.stockCode}</td>
                                                                                        <td>{item.name}</td>
                                                                                        <td className="text-end fw-bold">{item.quantity}</td>
                                                                                        <td className="text-end small text-muted">{item.unit}</td>
                                                                                        <td className="text-end font-monospace text-muted">{this.formatCurrency(item.price)}</td>
                                                                                        <td className="text-end font-monospace fw-bold text-dark">{this.formatCurrency(lineTotal)}</td>
                                                                                    </tr>
                                                                                );
                                                                            })}
                                                                        </tbody>
                                                                        <tfoot>
                                                                            <tr className="border-top">
                                                                                <td colSpan={5} className="text-end pt-2 text-muted small">İrsaliye Toplamı:</td>
                                                                                <td className="text-end pt-2 fw-bold text-primary fs-6">
                                                                                    {this.formatCurrency(waybillTotal)}
                                                                                </td>
                                                                            </tr>
                                                                        </tfoot>
                                                                    </Table>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </React.Fragment>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    );
                })}
            </Accordion>
        );
    }

    render() {
        return (
            <AuthorizedPage role={Role.SALES_ADMIN} isLoading={this.state.isLoading}>
                <div className="centered-99-percent">
                    <div className="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
                        <div>
                            <h4 className="mb-0 text-dark fw-bold">Sevkiyat & İrsaliye Yönetimi</h4>
                            <small className="text-muted">Sevkiyat bazlı gruplanmış irsaliye listesi</small>
                        </div>

                        <div className="d-flex gap-3 align-items-center">
                            {/* 🔥 YENİ FİLTRE: SWITCH */}
                            <Form.Check
                                type="switch"
                                id="hide-completed-switch"
                                label="Tamamlananları Gizle"
                                checked={this.state.hideCompleted}
                                onChange={this.handleFilterChange}
                                className="fw-bold text-secondary"
                                style={{cursor: 'pointer'}}
                            />

                            <Button variant="success" size="sm" onClick={() => this.loadData()} disabled={this.state.isLoading}>
                                {this.state.isLoading ? 'Yükleniyor...' : '🔄 Yenile'}
                            </Button>
                        </div>
                    </div>

                    {/* OrderQueryFilter KALDIRILDI */}
                    {this.renderShipmentGroups()}

                    <InfoToast
                        show={this.state.toastShow}
                        onClose={() => this.setState({ toastShow: false })}
                        text={this.state.toastMessage}
                        variant={this.state.toastVariant}
                        delay={this.state.toastDelay}
                    />

                    <Modal
                        show={this.state.modalShow}
                        onHide={() => this.setState({ modalShow: false })}
                        centered
                        backdrop="static"
                        keyboard={false}
                    >
                        <Modal.Header closeButton className="bg-danger text-white">
                            <Modal.Title>⚠️ İşlem Başarısız</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ fontSize: '15px' }}>
                            {this.state.modalMessage.split("\n").map((line: string, i: number) => (
                                <div key={i} className="mb-1">
                                    {line.startsWith("•") ? line : "• " + line}
                                </div>
                            ))}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => this.setState({ modalShow: false })}>
                                Kapat
                            </Button>
                        </Modal.Footer>
                    </Modal>

                </div>
            </AuthorizedPage>
        );
    }
}

export default SalesWaybills;